import { mergeQueryTypes }     from '../util/network/QueryUtility';
import { OrganizationQueries } from './OrganizationQueries';
import { ProjectQueries }      from './ProjectQueries';
import { QuerySetKeys }        from '../types';
import { AccountQueries }      from './AccountQueries';

const querySets = [
	AccountQueries,
	OrganizationQueries,
	ProjectQueries,
];

type QuerySegmentType<D extends QuerySetKeys> =
	typeof AccountQueries[D] &
	typeof OrganizationQueries[D] &
	typeof ProjectQueries[D];

const SystemAccountingQueries = {
	fragments: mergeQueryTypes( querySets, 'fragments' ) as QuerySegmentType<'fragments'>,
	queries:   mergeQueryTypes( querySets, 'queries' ) as QuerySegmentType<'queries'>,
	mutations: mergeQueryTypes( querySets, 'mutations' ) as QuerySegmentType<'mutations'>,
};

export { SystemAccountingQueries }

